import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const StyledTypography = styled(Typography)`
  background-color: ${props => !props.selected ? "transparent" : "#d6d8d9"};
  width: calc(100% + 32px);
  margin: -8px -16px;
  padding: 9px;
`